module.exports = __webpack_public_path__ + "img/captain_icon.8a1de0f2.jpg";